/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiAddParticipantToConversation,
    BridgeApiAddParticipantToConversationFromJSON,
    BridgeApiAddParticipantToConversationToJSON,
    BridgeApiConversation,
    BridgeApiConversationFromJSON,
    BridgeApiConversationToJSON,
    BridgeApiCreateConversationV2,
    BridgeApiCreateConversationV2FromJSON,
    BridgeApiCreateConversationV2ToJSON,
    BridgeApiUpdateConversation,
    BridgeApiUpdateConversationFromJSON,
    BridgeApiUpdateConversationToJSON,
} from '../models';

export interface AddConversationParticipantRequest {
    conversationId: string;
    bridgeApiAddParticipantToConversation: BridgeApiAddParticipantToConversation;
}

export interface CreateConversationRequest {
    bridgeApiCreateConversationV2: BridgeApiCreateConversationV2;
}

export interface GetConversationByHandleRequest {
    id: string;
}

export interface UpdateConversationRequest {
    id: string;
    bridgeApiUpdateConversation: BridgeApiUpdateConversation;
}

/**
 * 
 */
export class BridgeConversationApi extends runtime.BaseAPI {

    /**
     * Add participant to conversation participant
     */
    async addConversationParticipantRaw(requestParameters: AddConversationParticipantRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversation>> {
        if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
            throw new runtime.RequiredError('conversationId','Required parameter requestParameters.conversationId was null or undefined when calling addConversationParticipant.');
        }

        if (requestParameters.bridgeApiAddParticipantToConversation === null || requestParameters.bridgeApiAddParticipantToConversation === undefined) {
            throw new runtime.RequiredError('bridgeApiAddParticipantToConversation','Required parameter requestParameters.bridgeApiAddParticipantToConversation was null or undefined when calling addConversationParticipant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation/{conversationId}/participant`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters.conversationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BridgeApiAddParticipantToConversationToJSON(requestParameters.bridgeApiAddParticipantToConversation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationFromJSON(jsonValue));
    }

    /**
     * Add participant to conversation participant
     */
    async addConversationParticipant(requestParameters: AddConversationParticipantRequest, initOverrides?: RequestInit): Promise<BridgeApiConversation> {
        const response = await this.addConversationParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a conversation
     */
    async createConversationRaw(requestParameters: CreateConversationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversation>> {
        if (requestParameters.bridgeApiCreateConversationV2 === null || requestParameters.bridgeApiCreateConversationV2 === undefined) {
            throw new runtime.RequiredError('bridgeApiCreateConversationV2','Required parameter requestParameters.bridgeApiCreateConversationV2 was null or undefined when calling createConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/conversations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BridgeApiCreateConversationV2ToJSON(requestParameters.bridgeApiCreateConversationV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationFromJSON(jsonValue));
    }

    /**
     * Create a conversation
     */
    async createConversation(requestParameters: CreateConversationRequest, initOverrides?: RequestInit): Promise<BridgeApiConversation> {
        const response = await this.createConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get conversation
     */
    async getConversationByHandleRaw(requestParameters: GetConversationByHandleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getConversationByHandle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationFromJSON(jsonValue));
    }

    /**
     * Get conversation
     */
    async getConversationByHandle(requestParameters: GetConversationByHandleRequest, initOverrides?: RequestInit): Promise<BridgeApiConversation> {
        const response = await this.getConversationByHandleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update conversation
     */
    async updateConversationRaw(requestParameters: UpdateConversationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateConversation.');
        }

        if (requestParameters.bridgeApiUpdateConversation === null || requestParameters.bridgeApiUpdateConversation === undefined) {
            throw new runtime.RequiredError('bridgeApiUpdateConversation','Required parameter requestParameters.bridgeApiUpdateConversation was null or undefined when calling updateConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BridgeApiUpdateConversationToJSON(requestParameters.bridgeApiUpdateConversation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationFromJSON(jsonValue));
    }

    /**
     * Update conversation
     */
    async updateConversation(requestParameters: UpdateConversationRequest, initOverrides?: RequestInit): Promise<BridgeApiConversation> {
        const response = await this.updateConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
